import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';
import { SpecialPage } from './pages/special/special';
import { SpecialPageFull } from './pages/special/special.full';
import { SpecialCommon } from './pages/special/special.common';
import { SpecialData }from'./providers/special-data';

//Export
export { SpecialPage } from './pages/special/special';
export { SpecialPageFull } from './pages/special/special.full';

// Router Config
const routerConfig:any = [    
    { component: SpecialPage, fullComponent: SpecialPageFull,  name: 'Special', segment: 'special' }
]

@NgModule({
    imports: [
        IonicModule
    ],
    declarations: [
        SpecialPage,
        SpecialPageFull
    ],
    exports: [
        SpecialPage,
        SpecialPageFull
    ],
    bootstrap: [],
    entryComponents: [
        SpecialPage,
        SpecialPageFull
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}, SpecialData, SpecialCommon]
})
export class SpecialModule{

	constructor(public pageRef: PageRef){
       this.pageRef.addCfgLinks(routerConfig); 
	}
}


// WEBPACK FOOTER //
// ./src/modules/special/special.module.ts